import CreateVip from './Create'
import UpdateVip from './Update'


export {
    CreateVip,
    UpdateVip
}